import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=2c3a2492&scoped=true"
import script from "./uploadVideo.vue?vue&type=script&lang=js"
export * from "./uploadVideo.vue?vue&type=script&lang=js"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=2c3a2492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a2492",
  null
  
)

export default component.exports